import React from 'react';
import styled from 'styled-components';

import WhiteLogoCardTop from '../../cards/card-content/WhiteLogoCardTop';
import FullCardTop from '../../cards/card-content/FullCardTop';
import BasicCardTop from '../../cards/card-content/BasicCardTop';

import Text from '@basic/Text';
import HTMLWrapper from '@basic/HTMLWrapper';
import documentToReactComponents from '../../util/documentToReactComponents';

import Link from '../../util/link';
import theme from '../../../styles/theme';

const { 
    cardBoxShadow, 
    transitionDuration, 
    colors, 
    card: {cardPadding},
    hoverBoxShadow, 
    breakPoints: { mobileFirstScreenQuery } 
} = theme;

const CardWrapper = styled(Link)`
        display: flex;
        flex-direction: column;
        background-color: #fff;
        box-shadow: ${cardBoxShadow};
        transition: box-shadow ${transitionDuration} ease;
        max-width: 365px;
        position: relative;

	* {
		transition-duration: ${theme.transitionDuration};
	}
	box-shadow: ${theme.cardBoxShadow};
	svg {
		fill: ${colors.brandMain};
	}
	:hover {
		cursor: pointer;
		box-shadow: ${hoverBoxShadow};
		.play-button {
			opacity: 1;
		}
		svg {
			fill ${colors.primary.dark};
		}
	}


    .basic-card__top-image-wrapper {
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 40px 0;

        svg {
            position: absolute;
            width: 80px;
        }
    }

    .basic-card__description {
		color: ${colors.black};
		margin-bottom: 0;
		margin-top: 5px;
		font-size: 16px;
		line-height: 20px;
	}

    .basic-card__top {
        min-height: 250px;
        height: 250px;
        width: 100%;
    }

    .basic-card__bottom {
        /*interesting hack to target a child if it's the *only* one: */
        > :first-child:nth-last-child(1) {
            padding: 30px 0;
        }

        padding: ${cardPadding}px;
        ${(props) => (props.link ? `padding-bottom: 60px;` : "")}
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: 300px;
    }
}`
 
const BasicCard = ({
    index,
    title,
    description,
    cardImage,
    type,
    link,
    linkText,
    noArrow,
    fullCardImage,
    chevron
    }) => {
    
    const HTMLDescription = description?.childMarkdownRemark?.html;
    const rawDescription = typeof description === "object"

    return (
        <CardWrapper to={link} className="basic-card__wrapper">
            <div className="basic-card__top">
                <div className="basic-card__top-image-wrapper">
                    {cardImage && (
                        type === 'ContentfulPageTemplateCustomerStory' ? (
                            <WhiteLogoCardTop cardImage={cardImage} index={index} />
                        ) : (type === 'ContentfulPageTemplateWebinar' || fullCardImage) ? (
                            <FullCardTop cardImage={ cardImage } />
                        ) : <BasicCardTop cardImage={ cardImage }/>
                    )}
                </div>
            </div>
            <div className="basic-card__bottom" link={linkText}>
                <div className="basicCard__bottom-text" link={linkText}>
                    {title && (
                        <Text component="h5">
                            {title}
                        </Text>
                    )}
                    {HTMLDescription ? (
                        <Text component="b5">
                            <HTMLWrapper html={HTMLDescription} color={colors.black} />
                        </Text>            
                    ) : rawDescription ? (
                        <span className="basic-card__description">{documentToReactComponents(description)}</span>
                    ) : (
                        <Text component="b5">{description}</Text> 
                    )}
                </div>
                {linkText && (
                    <Text className="basic-card__link" component="h8" color="brandMain">
                        {linkText} {!noArrow && "→"} {chevron && ">"}
                    </Text>
                )}
            </div>
        </CardWrapper>
    )
}
 
export default BasicCard